import { combineReducers } from 'redux';
import { Manager_leads_manage } from './leads_manage.reducer';

export const ManagerLeads = combineReducers({
    Manager_leads_manage,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Manager_special/redux/reducers/index.js